import React from "react";

import ReactVirtualizedAutoSizer from "react-virtualized-auto-sizer";

import { useVirtualizer } from "@tanstack/react-virtual";

export function RowVirtualizerDynamic<Value>({
  rows,
  Row,
  className,
  style,
}: {
  style?: React.HTMLAttributes<HTMLDivElement>["style"];
  className?: string;
  rows: Value[];
  Row: (props: {
    row: Value;
    element?: Element;
    index: number;
    totalCount: number;
  }) => JSX.Element;
}) {
  const parentRef = React.useRef<HTMLDivElement>(null);

  const count = rows.length;
  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 45,
  });

  const items = virtualizer.getVirtualItems();

  return (
    <ReactVirtualizedAutoSizer disableWidth>
      {({ height }) => {
        return (
          <div
            ref={parentRef}
            className={className}
            style={{
              height,
              overflowY: "auto",
              contain: "strict",
              ...style,
            }}
          >
            <div
              style={{
                height: virtualizer.getTotalSize(),
                width: "100%",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  transform: `translateY(${items?.[0]?.start ?? 0}px)`,
                }}
              >
                {items.map((virtualRow) => {
                  const row = rows[virtualRow.index];
                  return (
                    <div
                      key={virtualRow.key}
                      data-index={virtualRow.index}
                      ref={virtualizer.measureElement}
                    >
                      <Row
                        row={row}
                        element={virtualizer.measureElementCache.get(
                          virtualRow.index,
                        )}
                        index={virtualRow.index}
                        totalCount={count}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      }}
    </ReactVirtualizedAutoSizer>
  );
}
